import apiClient from "./client";

export const submitRegistration = async (data: FormData) => {
  const res = await apiClient({
    url: "/public/registration",
    method: "POST",
    data,
  });
  return res.data;
};
